/** 从工作台返回首页时，用于高亮对应快速入口（sessionStorage，一次性消费） */
export const MOBILE_ISLAND_LAST_WORKBENCH_PATH_KEY = 'erpMobileLastWorkbenchPath';

export const normalizeMobileWorkbenchPath = (path) => {
	if (!path) {
		return '';
	}
	const base = String(path).split('?')[0].split('#')[0];
	if (base.length > 1 && base.endsWith('/')) {
		return base.slice(0, -1);
	}
	return base;
};

export const mobileWorkbenchPathsMatch = (left, right) => normalizeMobileWorkbenchPath(left) === normalizeMobileWorkbenchPath(right);

export const readMobileLastWorkbenchPath = () => {
	if (typeof window === 'undefined') {
		return null;
	}
	try {
		const value = window.sessionStorage.getItem(MOBILE_ISLAND_LAST_WORKBENCH_PATH_KEY);
		return value ? normalizeMobileWorkbenchPath(value) : null;
	} catch {
		return null;
	}
};

export const writeMobileLastWorkbenchPath = (path) => {
	if (typeof window === 'undefined' || !path) {
		return;
	}
	try {
		window.sessionStorage.setItem(MOBILE_ISLAND_LAST_WORKBENCH_PATH_KEY, normalizeMobileWorkbenchPath(path));
	} catch {
		// ignore quota / private mode
	}
};

export const consumeMobileLastWorkbenchPath = () => {
	const path = readMobileLastWorkbenchPath();
	if (!path) {
		return null;
	}
	if (typeof window !== 'undefined') {
		try {
			window.sessionStorage.removeItem(MOBILE_ISLAND_LAST_WORKBENCH_PATH_KEY);
		} catch {
			// ignore
		}
	}
	return path;
};
